import React, { lazy, Suspense } from "react";

export { default as ReTenantList } from "./ReTenantList";

const LazyView_TenantTakeMoney = lazy(() => import("./ReView_TenantTakeMoney"));
const LazyReView_TenantParadan = lazy(() => import("./ReView_TenantParadan"));
const LazyReView_TenantContract = lazy(() => import("./ReView_TenantContract"));
const LazyPrintListTenant = lazy(() => import("./PrintListTenant"));
export const ReView_TenantTakeMoney = () => (
  <Suspense fallback="loading...">
    <LazyView_TenantTakeMoney />
  </Suspense>
);
export const ReView_TenantParadan = () => (
  <Suspense fallback="loading...">
    <LazyReView_TenantParadan />
  </Suspense>
);
export const ReView_TenantContract = () => (
  <Suspense fallback="loading...">
    <LazyReView_TenantContract />
  </Suspense>
);
export const PrintListTenant = () => (
  <Suspense fallback="loading...">
    <LazyPrintListTenant />
  </Suspense>
);
